
import { doc, collection, setDoc } from 'firebase/firestore';
import { FirebaseError } from 'firebase/app';
import { db } from '../firebase';
import { 
  handleFirestoreError, 
  OperationType 
} from '../errorHandlingService';
import { BUSINESS_COLLECTION } from './constants';

// Helper function to remove undefined values from an object
const removeUndefinedValues = (obj: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {};
  Object.keys(obj).forEach(key => {
    if (obj[key] !== undefined) {
      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        result[key] = removeUndefinedValues(obj[key]);
      } else {
        result[key] = obj[key];
      }
    }
  });
  return result;
};

// Map application field names to database field names
const mapToDbFieldNames = (data: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = { ...data };
  
  // Map 'status' to 'lead_status'
  if ('status' in result) {
    result.lead_status = result.status;
    delete result.status;
  }
  
  // Map 'outcome' to 'lead_outcome'
  if ('outcome' in result) {
    result.lead_outcome = result.outcome;
    delete result.outcome;
  }
  
  return result;
};

// Update lead data - now using a cleaner subcollection structure
export const updateLead = async (leadId: string, businessId: string, data: any): Promise<void> => {
  try {
    // Map application field names to database field names
    const mappedData = mapToDbFieldNames(data);
    
    // Sanitize the data to remove undefined values
    const sanitizedData = removeUndefinedValues(mappedData);
    console.log(`Updating lead ${leadId} with sanitized data:`, sanitizedData);
    
    // Store leads in the new path structure: businesses/{businessId}/leads/{leadId}
    const leadRef = doc(collection(db, BUSINESS_COLLECTION, businessId, 'leads'), leadId);
    await setDoc(leadRef, sanitizedData, { merge: true });
    
    console.log(`Lead ${leadId} updated in Firestore`);
  } catch (error) {
    // Use our new error handling
    handleFirestoreError(
      error as FirebaseError, 
      OperationType.UPDATE, 
      leadId, 
      `${BUSINESS_COLLECTION}/${businessId}/leads`
    );
    throw error;
  }
};
